export const USERPERFORMANCE_REQUEST = "USERPERFORMANCE_REQUEST";
export const USERPERFORMANCE_SUCCESS = "USERPERFORMANCE_SUCCESS";
export const USERPERFORMANCE_FAILURE = "USERPERFORMANCE_FAILURE";